import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Settings } from '@hub/common/Settings';
import { HttpClientService } from '@hub/services/HttpClientService';

@Component({
	selector: 'app-sync-booking',
	template: `
<div class="bg-contain m-3 p-2">
	<h3 *ngIf="loading">Syncing booking...</h3>
	<pre *ngIf="!loading">{{ result | json }}</pre>
</div>
`
})
export class SyncBookingComponent implements OnInit {
	loading = true;
	result: any;

	constructor(private route: ActivatedRoute, private httpClientService: HttpClientService) {
	}

	ngOnInit(): void {
		const id = this.route.snapshot.queryParamMap.get('id');

		if (!id) {
			this.loading = false;
			this.result = { Status: 'Failed', Message: 'Missing id query parameter.' };
			return;
		}

		this.httpClientService.get<any>(Settings.createApiUrl('TVPackages/SyncBooking'), { id })
			.subscribe({
				next: response => {
					this.loading = false;
					this.result = response;
				},
				error: err => {
					this.loading = false;
					this.result = { Status: 'Failed', Message: err?.error?.Message || err?.message || 'Request failed.' };
				}
			});
	}
}
